export const products = [
  {
    id: 1,
    name: "KENDIMIZ BAL 900 GR",
    price: 5.19,
    img: "../assets/image/product1.jpg",
  },
  {
    id: 2,
    name: "KENDIMIZ BAL 700 GR",
    price: 3.19,
    img: "../assets/image/product1.jpg",
  },
  {
    id: 3,
    name: "KENDIMIZ BAL 500 GR",
    price: 4.19,
    img: "../assets/image/product1.jpg",
  },
];
